import { useEffect, useRef, useState } from 'react';
import { maxBy } from 'lodash';

interface ElementRatio {
  element: HTMLElement;
  ratio: number;
}

export const useScrollSpy = (elements: HTMLElement[]) => {
  const [activeElement, setActiveElement] = useState<HTMLElement | undefined>();

  const elementsWithRatio = useRef<ElementRatio[]>([]);
  useEffect(() => {
    elementsWithRatio.current = elements.map((element) => ({ element, ratio: 0 }));

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const item = elementsWithRatio.current.find(
            (element) => element.element === entry.target
          );
          if (!item) return;
          item.ratio = entry.isIntersecting ? entry.intersectionRatio : 0;
        });

        const mostVisible = maxBy(elementsWithRatio.current, (itm) => itm.ratio);

        if (mostVisible && mostVisible.ratio > 0) {
          setActiveElement(mostVisible.element);
        }
      },
      { threshold: [0, 0.25, 0.5, 0.75, 1], rootMargin: '0px', root: null }
    );

    elements.forEach((element) => {
      if (!element) {
        return;
      }
      observer.observe(element);
    });

    return () => observer.disconnect();
  }, [elements]);

  return activeElement;
};
